import { render } from "./AppointmentModal.vue?vue&type=template&id=0ef146be"
import script from "./AppointmentModal.vue?vue&type=script&lang=js"
export * from "./AppointmentModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__